import type { Geofence, TimestampInMillis, UUID } from '@cobliteam/common-types';

import type { LatLng } from '../geocode';

interface ApiFuelCostEntry {
  begin_day: TimestampInMillis;
  cost: number;
  driver_ids: string[];
  distance_driven_in_meters: number;
}

interface StepGeofenceApi {
  address: string;
  category: string | null;
  center: LatLng;
  created_at: number;
  id: UUID;
  name: string;
  radius: number;
}

export enum IncidentType {
  DEVICE_PLUGGED = 'device_plugged',
  DEVICE_UNPLUGGED = 'device_unplugged',
  DEVICE_BADLY_CONNECTED = 'device_badly_connected',
  DEVICE_INACTIVE = 'device_inactive',
  UNKNOWN = 'unknown',
}

export interface Incident {
  type: IncidentType;
  time: number;
  latitude?: number;
  longitude?: number;
}

export interface ApiFuelCosts {
  [vehicle_id: string]: ApiFuelCostEntry[];
}

interface ApiMaintenanceCostsEntry {
  begin_day: TimestampInMillis;
  corrective: number;
  preventive: number;
}

export interface ApiMaintenanceCosts {
  [vehicle_id: string]: ApiMaintenanceCostsEntry[];
}

export enum RouteStepType {
  STOP = 'stop',
  TRIP = 'trip',
}

export interface RouteStepApi {
  start_time: TimestampInMillis;
  end_time: TimestampInMillis;
  driver_id?: UUID;
  type: RouteStepType;
  cost: number;
}

export interface StopRouteStepApi extends RouteStepApi {
  device_id: string;
  latitude: number;
  longitude: number;
  idle_on_in_millis: number;
  idle_off_in_millis: number;
  has_filtered_idle_on_time: boolean;
  geofences: StepGeofenceApi[];
}

export interface TripRouteStepApi extends RouteStepApi {
  trip_distance: number;
  cost: number;
}

export interface VehicleFieldsApi {
  id: UUID;
  license_plate: string;
  brand: string;
  model: string;
}

export interface VehicleRouteApi {
  vehicle: VehicleFieldsApi;
  route_steps: RouteStepApi[];
  incidents: Incident[];
}

export interface VehicleRouteFilters {
  wantedGroups?: UUID[];
  wantedVehicleIds?: UUID[];
}

export interface RouteStep {
  startTime: TimestampInMillis;
  endTime: TimestampInMillis;
  driverId?: UUID;
  type: RouteStepType;
  cost: number;
}

export interface StopRouteStep extends RouteStep {
  deviceId: string;
  latitude: number;
  longitude: number;
  idleOnInMillis: number;
  idleOffInMillis: number;
  hasFilteredIdleOnTime: boolean;
  geofences: Geofence[];
}

export interface TripRouteStep extends RouteStep {
  tripDistance: number;
}

export interface VehicleFields {
  id: UUID;
  licensePlate: string;
  brand: string;
  model: string;
}

export interface VehicleRoute {
  vehicle: VehicleFields;
  routeSteps: RouteStep[];
  incidents: Incident[];
}

interface IdleEngineBase {
  totalIdleInMinutes: number;
  totalStoppedInMinutes: number;
  percentageIdle: number;
}

export interface CostsVehicleIdleEngineAggregation extends IdleEngineBase {
  vehicleId: UUID;
  deviceId: string;
}

export interface CostsDriverIdleEngineAggregation extends IdleEngineBase {
  driverId: UUID;
}

export interface CostsIdleEngineEvent extends IdleEngineBase {
  vehicleId: UUID;
  driverId: UUID;
  deviceId: string;
  dateInMillis: TimestampInMillis;
}
